/**
 * Runtime config.
 *
 * At container start, /docker-entrypoint.d/40-generate-config.sh generates
 * /config.js which sets window.__APP_CONFIG__ with VUE_APP_* values from
 * environment variables (sourced from Vault via docker/.env).
 *
 * Webpack inlines process.env.VUE_APP_* at build time, so changing
 * process.env at runtime has no effect. This module reads
 * window.__APP_CONFIG__ directly, with process.env as fallback for dev.
 */

export function getEnv(name: string): string {
  const cfg = (window as any).__APP_CONFIG__;
  if (cfg && cfg[name] !== undefined) {
    return cfg[name];
  }
  return (process.env as any)[`VUE_APP_${name}`] || '';
}
